module.exports = __webpack_public_path__ + "static/media/A.6792e3ad.png";